import { useState, useEffect } from 'react';
import { getTenantIdFromStorage } from '../authentication/supertokens';

export interface OrganizationDetails {
    id: string;
    name: string;
    description?: string;
    stripe_account_id?: string;
    createdAt: string;
    updatedAt: string;
}

const fetchOrganizationDetails = async (): Promise<OrganizationDetails> => {
    const tenantId = getTenantIdFromStorage();
    
    if (!tenantId) {
        throw new Error('No tenant ID found in storage');
    }

    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/organizations/${tenantId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Failed to fetch organization details');
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching organization details:', error);
        throw error;
    }
};

export const useOrganization = () => {
    const [organization, setOrganization] = useState<OrganizationDetails | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        const fetchOrganization = async () => {
            try {
                const details = await fetchOrganizationDetails();
                setOrganization(details);
            } catch (err) {
                setError(err instanceof Error ? err : new Error('Failed to fetch organization'));
            } finally {
                setLoading(false);
            }
        };

        fetchOrganization();
    }, []);

    return { organization, loading, error };
}; 